<template>
  <ul class="kt-menu__nav">
    <template v-for="(menu, i) in getMenuItems()">
      <KTMenuItem
        v-if="!menu.section && checkMenuPermissions(menu)"
        :menu="menu"
        :key="i"
      ></KTMenuItem>
      <KTMenuSection v-if="menu.section" :menu="menu" :key="i"></KTMenuSection>
    </template>
  </ul>
</template>

<script>
import { mapGetters } from "vuex";
import KTMenuItem from "@/views/theme/aside/MenuItem.vue";
import KTMenuSection from "@/views/theme/aside/MenuSection.vue";
import menuConfig from "@/common/config/menu.config.json";

export default {
  name: "KTAsideMenu",
  components: {
    KTMenuItem,
    KTMenuSection
  },
  computed: {
    ...mapGetters(["getSection"])
    // menuItems: () => {
    //   return menuConfig.aside.items;
    // }
  },
  created() {},
  methods: {
    getMenuItems() {
      var items = [];

      switch (this.getSection) {
        case "admin":
          items = menuConfig.aside.admin.items;
          break;
        default:
          items = menuConfig.aside.default.items;
          break;
      }

      return items;
    },
    checkMenuPermissions(items) {
      const permissions = items.permissions || [];
      var self = this;

      if (permissions.length) {
        var userPerms = permissions.filter(permission => {
          return self.$auth().can(permission);
        });

        return userPerms.length > 0;
      }

      return true;
    }
  }
};
</script>
